import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
    *,*::before,*::after,h1,h2,h3,h4,h5,h6 {
        margin: 0px;
        padding: 0px;
    }
    html{
        scroll-behavior: smooth;
    }
    html::-webkit-scrollbar {
        display: none;
    }
    body{
        margin: 0px;
        padding: 0px;
        overflow-x: hidden;
        font-family: 'Ubuntu', sans-serif;
    }
    .img{
        min-height: 300px;
    }
`
export default GlobalStyle;